module.exports = __webpack_public_path__ + "img/article-gb-dwrg-5.5bc611b4.jpg";